module.exports = __webpack_public_path__ + "img/PX-logo_white-green.b774e2ce.png";